import { call, put, select } from 'redux-saga/effects'
import { takeEvery } from 'redux-saga'
import { getMaxZoomLevelForLatLng } from 'sagas/zoomToSingleCameraSaga'
import fitBounds from 'helpers/map/fitBounds'
import { mapSelector } from 'selectors'
import { ZOOM_TO_WIRED_DEVICE } from 'actions/mapTypes'
import { notifyHoneybadgerAction } from 'actions/applicationActions'

export function * zoomToWiredDevice(action) {
  try {
    const { wiredDevice, checkMaxZoom } = yield action
    const { map: { ref } } = yield select(mapSelector)

    if (EXPORT && checkMaxZoom) {
      const { zoom, error } = yield call(getMaxZoomLevelForLatLng, new google.maps.MaxZoomService(), wiredDevice.location)
      if (zoom) ref.setOptions({ maxZoom: zoom })
      else if (error) console.warn(error)
    } else if (EXPORT && !checkMaxZoom) {
      ref.setOptions({ maxZoom: null })
    }

    const bounds = new google.maps.LatLngBounds()
    bounds.extend(wiredDevice.location)

    yield call(fitBounds, { ref, bounds })
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

export function * watchZoomToWiredDevice() {
  yield * takeEvery(ZOOM_TO_WIRED_DEVICE, zoomToWiredDevice)
}



// WEBPACK FOOTER //
// ./src/sagas/zoomToWiredDeviceSaga.js